import React from 'react';
const defaultContext = {};
export const ModalContext = /*#__PURE__*/React.createContext(defaultContext);
export const useModalContext = () => React.useContext(ModalContext);